// @ts-nocheck
import React, {FC, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router";
import {
    Badge,
    Box,
    Button,
    Checkbox,
    CloseButton,
    Divider,
    Flex,
    Grid,
    Icon,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Menu,
    MenuButton,
    MenuGroup,
    MenuItem,
    MenuList,
    IconButton,
    Radio,
    RadioGroup,
    Stack,
    Text,
    Tooltip,
    Input,
    Textarea,
    useBreakpointValue,
    useToast,
    VStack
} from "@chakra-ui/react";
import {useAppSelector} from "../../redux/Store";
import {ListProductItemConfig, ListProductItemRow} from "../../components/List/ListProductItem";
import {Loader} from "../../components/Loader/Loader";
import {OrderController} from "../../controllers/OrderController";
import {OrderRepositoryInstance} from "../../repository/Order/OrderRepository";
import {Order, OrderTypes, PaymentTypes, ReqOrderConfig} from "../../shared/entities/Order/Order";
import {URLPaths} from "../../config/application/URLPaths";
import {Paginator} from "../../components/Paignator/Paginator";
import {ModalService} from "../../service/Modal/ModalService";
import {DocumentTypes} from "../../common/constants";
import {Breadcrumbs} from "../../components/Breadcrumbs/Breadcrumbs";
import {setBreadcrumbsLinks} from "../../redux/Breadcrumbs/BreadcrumbsReducer";
import {BreadcrumbsData} from "../../shared/entities/Breadcrumbs/BreadCrumbsData";
import {AngleDoubleRight} from "../../components/Inputs/Icons/Icons";
import ShowOrderModal from "../Modal/ShowOrderModal";
import {format, parse} from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import {
    FiBriefcase,
    FiCopy,
    FiCornerLeftDown,
    FiCornerRightUp,
    FiDownload,
    FiEye,
    FiFilter,
    FiPrinter,
    FiSend,
    FiTag,
    FiTrash,
    FiShoppingBag,
} from "react-icons/all";
import {BsThreeDotsVertical} from "react-icons/bs";
import IconWithTooltip from "../../components/Icon/IconWithTooltip";
import PDFViewer from "../Pdf/PDFViewer";
import {ClientForm} from "../Forms/Clients/ClientForm";
import {DownloaderInstance} from "../../service/Downloader/Downloder";
import fileDownload from "js-file-download";
import {AiOutlineClose, AiOutlineFileExcel} from "react-icons/ai";
import {hasPermission, isRoleAdmin} from "../../features/Permission/AllowedAccess";
import {
    clientViewPermission,
    dealershipExcludeSelectPermission,
    orderAdminNameShowPermission,
    orderAmountShowPermission,
    orderDealershipShowPermission,
    orderEditPermission,
    orderRefundPermission,
    orderIdShowPermission,
    orderRemovePermission,
    orderStatusShowPermission,
    orderViewPartnerPermission,
} from "../permissions";
import {OrderHistoryActionMenuConfig} from "./OrderHistorySelectionToolbar";
import LoadStatementVendorPopover from "../Modal/LoadStatementVendorPopover";
import {InvoiceSendModal} from "../Modal/InvoiceSendModal";
import {ReorderInvoiceModal} from "../Modal/ReorderInvoiceModal";
import {StripePaymentModal} from "../Modal/StripePaymentModal";
import {StripeController} from "../../controllers/StripeController";
import {UserController} from "../../controllers/UserController";
import {PaymentIntent, RefundRequest} from "../../shared/entities/Stripe/Stripe";
import {DealershipMinInfo} from "../../shared/entities/Users/Dealership";
import {isUserAllowedCardPayment} from "../../shared/utils/cardPaymentAccess";
import {OrderHistoryFilters} from "./OrderHistoryFilters";
import {
    ColumnDef,
    ColumnFiltersState,
    flexRender,
    getCoreRowModel,
    SortingState,
    useReactTable
} from "@tanstack/react-table";

const formatRefundCreated = (created: unknown): string => {
    if (created == null || created === "") return "N/A";
    if (typeof created === "string") {
        const d = new Date(created);
        return isNaN(d.getTime()) ? created : d.toLocaleString();
    }
    if (typeof created === "number") {
        const ms = created < 1e12 ? created * 1000 : created;
        return new Date(ms).toLocaleString();
    }
    if (Array.isArray(created) && created.length >= 1) {
        return new Date(Number(created[0]) * 1000).toLocaleString();
    }
    return String(created);
};

function escapeHtmlForPrint(s: unknown): string {
    if (s == null || s === "") return "";
    return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

export const OrderHistory: FC<{ links: Array<BreadcrumbsData>, account?: boolean }> = ({links, account = false}) => {
        const dispatch = useDispatch();
        const navigate = useNavigate();
        const toast = useToast()
        const {id} = useParams();
        const [isLoading, setIsLoading] = useState(false)
        const [isPrint, setIsPrint] = useState(false)
        const [isExcluded, setIsExcluded] = useState('1')
        const [isDocumentType, setIsDocumentType] = useState<DocumentTypes>(DocumentTypes.Invoice)
        const [isPdf, setPdf] = useState(0)
        const [idState, setIdState] = useState<any>(null);
        const [groupOrder, setGroupOrder] = useState<any>(null);
        const [refreshOrderHistory, setRefreshOrderHistory] = useState(false);
        const orderController = new OrderController(dispatch);
        const stripeController = new StripeController(dispatch);
        const userController = new UserController(dispatch);
        const canRemoveInLikeAfterSend = (o) => {
            if (!o) return false;
            if (o.paymentStatus === OrderTypes.CARD_PAID) {
                return (o.sendCount ?? 0) > 0 && ((o.printPressed ?? 0) > 0 || (o.cardPaymentDetailsPrintCount ?? 0) > 0);
            }
            return (o.sendCount ?? 0) > 0 && (o.printPressed ?? 0) > 0;
        };
        const [currentPaginatorPosition, setCurrentPaginatorPosition] = useState(0)
        const modalService = new ModalService(dispatch)
        const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
        const [sorting, setSorting] = useState<SortingState>([]);
        const orderClientList = useAppSelector(store => store?.OrderReducer?.orderClientList)
        const dealership = useAppSelector(state => state.AuthReducer.dealership);
        const user = useAppSelector(store => store.AuthReducer.user);
        const dealershipsMinInfo = useAppSelector(state => state.UserReducer.dealershipsMinInfo);
        const location = useLocation();
        const containsUser = location.pathname.includes("user");
        let isMobile = useBreakpointValue({base: true, sm: true, md: true, lg: false, xl: false, "2xl": false})
        const [selectedItems, setSelectedItems] = useState<any[]>([]);
        let countSelected = (isExcluded === '2') ? orderClientList?.count - selectedItems.length : selectedItems.length
        const [loadingInvoiceOrderId, setLoadingInvoiceOrderId] = useState<number | null>(null);
        const [loadingReminderOrderId, setLoadingReminderInvoiceOrderId] = useState<number | null>(null);
        const [reorderModalOpen, setReorderModalOpen] = useState(false);
        const [selectedOrderForReorder, setSelectedOrderForReorder] = useState<Order | null>(null);
        const [isVendorSalesModalOpen, setIsVendorSalesModalOpen] = useState(false);

        // Состояние для модального окна отправки
        const [isSendModalOpen, setIsSendModalOpen] = useState(false);
        const [ordersToSend, setOrdersToSend] = useState<Order[]>([]);
        const [flagReminder, setFlagReminder] = useState<boolean>(false);
        const [isPaymentIntentModalOpen, setIsPaymentIntentModalOpen] = useState(false);
        const [isPaymentIntentLoading, setIsPaymentIntentLoading] = useState(false);
        const [isStripeDetailsPrinting, setIsStripeDetailsPrinting] = useState(false);
        const [selectedPaymentIntent, setSelectedPaymentIntent] = useState<PaymentIntent | null>(null);
        const [selectedPaymentIntentId, setSelectedPaymentIntentId] = useState<string | null>(null);
        const [paymentRefunds, setPaymentRefunds] = useState<any[]>([]);
        const [isRefundSubmitting, setIsRefundSubmitting] = useState(false);
        const [refundMode, setRefundMode] = useState<"full" | "partial">("full");
        const [partialRefundAmount, setPartialRefundAmount] = useState<string>("");
        const [refundNoteMessage, setRefundNoteMessage] = useState<string>("");
        const [selectedOrderForRefund, setSelectedOrderForRefund] = useState<Order | null>(null);
        const [payInvoiceOrder, setPayInvoiceOrder] = useState<Order | null>(null);
        /** Только админ: число заказов в Card paid для бейджа (без записи в Redux) */
        const [cardPaidOrderCount, setCardPaidOrderCount] = useState<number | null>(null);
        const getFilterValueRef = useRef<(key: string) => string>(() => "");
        const getFilterIconColorRef = useRef<(columnId: string) => string>(() => "gray.400");
        const onHeaderFilterClickRef = useRef<(event: React.MouseEvent<HTMLElement>, columnId: string) => void>(() => {
        });
        const [showColumnHeaderFunnels, setShowColumnHeaderFunnels] = useState(true);

        const normalizeUsDateToApi = (value: string): string | undefined => {
            if (!value) return undefined;
            const parsed = parse(value, "MM-dd-yyyy", new Date());
            if (Number.isNaN(parsed.getTime())) return undefined;
            return format(parsed, "yyyy-MM-dd");
        };
        const buildFilters = (order?: any) => {
            const getFilterValue = getFilterValueRef.current;
            const reqOrderConfig: ReqOrderConfig = {
                params: {
                    page: (currentPaginatorPosition > 0) ? currentPaginatorPosition - 1 : 0,
                    size: 20,
                },
                data: {}
            }
            if (hasPermission(clientViewPermission)) {
                reqOrderConfig.data[containsUser ? "userId" : "dealerIds"] = (id ? containsUser ? parseInt(id) : [parseInt(id)] : undefined)
            } else {
                reqOrderConfig.data["dealerIds"] = hasPermission(dealershipExcludeSelectPermission)
                    ? (id ? [id] : user?.dealerships.filter(d => d.id && d.id !== 0).map(v => v.id as number))
                    : dealership?.id ? [dealership.id] : undefined;

            }
            reqOrderConfig.data["combineSending"] = !!id
            if (getFilterValue("dealership") !== "") {
                reqOrderConfig.data["dealerName"] = getFilterValue("dealership")
            }
            if (getFilterValue("user") !== "") {
                reqOrderConfig.data["userName"] = getFilterValue("user")
            }
            const fromDate = normalizeUsDateToApi(getFilterValue("dateFrom"));
            if (fromDate) {
                reqOrderConfig.data["from"] = fromDate
            }
            const toDate = normalizeUsDateToApi(getFilterValue("dateTo"));
            if (toDate) {
                reqOrderConfig.data["to"] = toDate
            }
            if (getFilterValue("amount") !== "") {
                reqOrderConfig.data["amount"] = getFilterValue("amount")
            }
            if (getFilterValue("status") !== "") {
                reqOrderConfig.data["statusesId"] = Number(getFilterValue("status"))
            }
            if (getFilterValue("order") !== "") {
                reqOrderConfig.data["invoiceId"] = getFilterValue("order")
            }

            reqOrderConfig.data["administrator"] = hasPermission(orderEditPermission)
            if (isExcluded) {
                reqOrderConfig.data["isExcluded"] = order ? false : (isExcluded === '2')
            }
            let items = order ? [order] : selectedItems;
            if (items) {
                reqOrderConfig.data["entityIds"] = items.map(item => item.id)
            }
            return reqOrderConfig;
        };

        useEffect(() => {
            setBreadcrumbsLinks(dispatch, links);
            if (dealership) {
                if (user?.id === undefined || user === null) return;
                const reqConfig = buildFilters()
                reqConfig.data["entityIds"] = [];
                if (sorting.length > 0) {
                    const sortFieldMap: Record<string, string> = {
                        date: "createdAt",
                        order: "invoiceId",
                        qnt: "qntProduct",
                        user: "userName",
                        dealership: "dealerName",
                        status: "statusesId",
                        amount: "amount",
                    };
                    const activeSort = sorting[0];
                    const mappedField = sortFieldMap[activeSort.id];
                    if (mappedField) {
                        reqConfig.data["sort"] = {
                            [mappedField]: activeSort.desc ? "DESC" : "ASC",
                        };
                    }
                }
                orderController.getOrderList(reqConfig).then(res => {
                    if (!containsUser && id && res.Some && res.Some.orders && res.Some.orders.length > 0) {
                        setBreadcrumbsLinks(dispatch, [...links,
                            {
                                link: `id}`,
                                text: `${res?.Some?.orders?.[0]?.dealership?.name || ""}`
                            }]);
                    }
                })
            }
            if (containsUser) {
                setBreadcrumbsLinks(dispatch, [...[URLPaths.HOME, URLPaths.ORDER_HISTORY],
                    {
                        link: `${id}`,
                        text: `${id || ""}`
                    }]);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [columnFilters, sorting, user, dealership, currentPaginatorPosition, id, refreshOrderHistory])

        useEffect(() => {
            setCurrentPaginatorPosition(0);
        }, [columnFilters, sorting]);

        useEffect(() => {
            if (!isRoleAdmin()) {
                return;
            }
            if (!dealership) {
                return;
            }
            if (user?.id === undefined || user === null) {
                return;
            }
            let cancelled = false;
            const reqConfig = buildFilters();
            reqConfig.params = {page: 0, size: 1};
            reqConfig.data.entityIds = [];
            reqConfig.data.statusesId = OrderTypes.CARD_PAID;
            if (sorting.length > 0) {
                const sortFieldMap: Record<string, string> = {
                    date: "createdAt",
                    order: "invoiceId",
                    qnt: "qntProduct",
                    user: "userName",
                    dealership: "dealerName",
                    status: "statusesId",
                    amount: "amount",
                };
                const activeSort = sorting[0];
                const mappedField = sortFieldMap[activeSort.id];
                if (mappedField) {
                    reqConfig.data.sort = {
                        [mappedField]: activeSort.desc ? "DESC" : "ASC",
                    };
                }
            }
            OrderRepositoryInstance.getOrderList(reqConfig).then((res) => {
                if (cancelled) {
                    return;
                }
                if (res?.None) {
                    setCardPaidOrderCount(0);
                    return;
                }
                setCardPaidOrderCount(typeof res.Some?.count === "number" ? res.Some.count : 0);
            });
            return () => {
                cancelled = true;
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [columnFilters, sorting, user, dealership, id, refreshOrderHistory, isExcluded]);

        useEffect(() => {
            if (hasPermission(orderDealershipShowPermission) && dealershipsMinInfo.length === 0) {
                userController.getDealershipMinInfoAll({}).then(() => {
                });
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [dealershipsMinInfo.length]);

        const handlePageChange = (newPage: number) => {
            setCurrentPaginatorPosition(newPage)
        }

        const handleReorderInvoice = async (order: Order) => {
            setSelectedOrderForReorder(order);
            setReorderModalOpen(true);
        }

        const refundedAmount = paymentRefunds.reduce((sum: number, refund: any) => {
            if (refund?.success && refund?.amount != null) {
                return sum + Number(refund.amount);
            }
            return sum;
        }, 0);

        const totalCapturedAmount =
            ((selectedPaymentIntent as (PaymentIntent & { amount_received?: number }) | null)?.amount_received)
            || selectedPaymentIntent?.amount;
        const totalCapturedAmountInMajor = (totalCapturedAmount || 0) / 100;
        const availableRefundAmount = Math.max(totalCapturedAmountInMajor - refundedAmount, 0);
        const canRefundByPaymentIntentStatus = (selectedPaymentIntent?.status || "").toLowerCase() === "succeeded";
        const enablePartialRefundUi = false;

        const handleSubmitRefund = async () => {
            if (!selectedOrderForRefund?.stripeTransactionId) return;
            if (!hasPermission(orderRefundPermission)) return;
            if (!canRefundByPaymentIntentStatus) {
                toast({
                    position: "top",
                    title: "Refund is allowed only for succeeded payments",
                    status: "warning",
                    duration: 3000,
                    isClosable: true,
                });
                return;
            }
            if (availableRefundAmount <= 0) {
                toast({
                    position: "top",
                    title: "No amount available for refund",
                    status: "warning",
                    duration: 3000,
                    isClosable: true,
                });
                return;
            }

            let amountForRefund: number | undefined = undefined;

            if (refundMode === "partial") {
                const parsed = Number(partialRefundAmount);
                if (!parsed || parsed <= 0) {
                    toast({
                        position: "top",
                        title: "Enter valid partial refund amount",
                        status: "warning",
                        duration: 3000,
                        isClosable: true,
                    });
                    return;
                }
                // Бэкенд ожидает сумму в основной валюте (как BigDecimal), сам вызывает convertToSmallestUnit(*100)
                amountForRefund = Math.round(parsed * 100) / 100;
                if (amountForRefund > availableRefundAmount + 1e-6) {
                    toast({
                        position: "top",
                        title: "Partial refund exceeds available amount",
                        status: "warning",
                        duration: 3000,
                        isClosable: true,
                    });
                    return;
                }
            }

            const refundRequest: RefundRequest = {
                paymentIntentId: selectedOrderForRefund.stripeTransactionId,
                amount: refundMode === "partial" ? amountForRefund : undefined,
                ...(refundNoteMessage.trim()
                    ? {
                        /** Stripe принимает только enum; для текста комментария дублируем в metadata */
                        reason: "requested_by_customer",
                        metadataKey: "refund_note",
                        metadataValue: refundNoteMessage.trim().slice(0, 500),
                    }
                    : {}),
            };

            try {
                setIsRefundSubmitting(true);
                const response = await stripeController.createRefund(refundRequest);
                toast({
                    position: "top",
                    title: response?.success ? "Refund created successfully" : "Refund failed",
                    description: response?.message || undefined,
                    status: response?.success ? "success" : "error",
                    duration: 4000,
                    isClosable: true,
                });

                const refunds = await stripeController.getRefundsForPayment(selectedOrderForRefund.stripeTransactionId);
                setPaymentRefunds(refunds || []);
                setRefreshOrderHistory(prev => !prev);
                if (response?.success) {
                    setRefundNoteMessage("");
                }
            } catch (e: any) {
                toast({
                    position: "top",
                    title: "Refund request failed",
                    description: e?.message || "Unknown error",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                });
            } finally {
                setIsRefundSubmitting(false);
            }
        };

        const handleShowPaymentIntent = async (order: Order) => {
            if (!order?.stripeTransactionId) {
                toast({
                    position: "top",
                    title: "Stripe transaction id not found for this order",
                    status: "warning",
                    duration: 3000,
                    isClosable: true,
                });
                return;
            }

            setIsPaymentIntentModalOpen(true);
            setIsPaymentIntentLoading(true);
            setSelectedPaymentIntent(null);
            setSelectedPaymentIntentId(order.stripeTransactionId);
            setSelectedOrderForRefund(order);
            setPaymentRefunds([]);
            setRefundMode("full");
            setPartialRefundAmount("");
            setRefundNoteMessage("");

            try {
                const [paymentIntent, refunds] = await Promise.all([
                    stripeController.getPaymentIntent(order.stripeTransactionId),
                    stripeController.getRefundsForPayment(order.stripeTransactionId),
                ]);
                setSelectedPaymentIntent(paymentIntent);
                setPaymentRefunds(refunds || []);
            } catch (e: any) {
                toast({
                    position: "top",
                    title: "Failed to load Stripe payment details",
                    description: e?.message || "Unknown error",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                });
            } finally {
                setIsPaymentIntentLoading(false);
            }
        };

        const getStripeStatusColorScheme = (status?: string): string => {
            switch ((status || "").toLowerCase()) {
                case "succeeded":
                    return "green";
                case "processing":
                    return "orange";
                case "requires_payment_method":
                case "requires_confirmation":
                case "requires_action":
                    return "yellow";
                case "canceled":
                    return "red";
                default:
                    return "gray";
            }
        };

        const handleClosePaymentIntentModal = () => {
            setIsPaymentIntentModalOpen(false);
            setRefreshOrderHistory((prev) => !prev);
        };

        const handleCardPaymentDetailsPrint = async () => {
            const order = selectedOrderForRefund;
            if (!order?.id || !selectedPaymentIntent) {
                return;
            }
            setIsStripeDetailsPrinting(true);
            try {
                const res = await orderController.cardPaymentDetailsPrintPressed(buildFilters(order));
                if (res && (res.None || res.Some === false)) {
                    const msg = res?.None?.message || "Could not record card payment details print";
                    toast({
                        position: "top",
                        title: "Error",
                        description: msg,
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                    return;
                }
                const pi = selectedPaymentIntent;
                const cur = (pi.currency || "").toUpperCase();
                const refundRows = (paymentRefunds || [])
                    .map(
                        (refund: any, idx: number) =>
                            `<tr><td>${idx + 1}</td><td>${escapeHtmlForPrint(refund.refundId)}</td><td>${escapeHtmlForPrint(formatRefundCreated(refund.created))}</td><td>${escapeHtmlForPrint(refund.amount)}</td><td>${escapeHtmlForPrint(refund.note)}</td><td>${refund.success ? "Success" : "Failed"}</td></tr>`,
                    )
                    .join("");
                const bodyHtml = `
<h1>Stripe payment details — order #${escapeHtmlForPrint(order.id)}</h1>
<table>
  <tr><th>Field</th><th>Value</th></tr>
  <tr><td>Payment Intent ID</td><td>${escapeHtmlForPrint(pi.id)}</td></tr>
  <tr><td>Status</td><td>${escapeHtmlForPrint(pi.status)}</td></tr>
  <tr><td>Amount</td><td>${escapeHtmlForPrint(((pi.amount || 0) / 100).toFixed(2))} ${cur}</td></tr>
  <tr><td>Created</td><td>${escapeHtmlForPrint(new Date((pi.created || 0) * 1000).toLocaleString())}</td></tr>
  <tr><td>Stripe customer</td><td>${escapeHtmlForPrint(pi.customer)}</td></tr>
  <tr><td>Receipt email</td><td>${escapeHtmlForPrint(pi.receipt_email || pi.metadata?.customer_email)}</td></tr>
  <tr><td>Description</td><td>${escapeHtmlForPrint(pi.description)}</td></tr>
</table>
<h2>Refunds</h2>
<table><thead><tr><th>#</th><th>Refund ID</th><th>Date</th><th>Amount</th><th>Comment</th><th>Status</th></tr></thead><tbody>${refundRows || "<tr><td colspan=\"6\">No refunds</td></tr>"}</tbody></table>`;
                const doc = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Order ${order.id} — Stripe</title>
<style>body{font-family:system-ui,-apple-system,sans-serif;padding:24px;color:#111} table{border-collapse:collapse;width:100%;margin-bottom:16px} th,td{border:1px solid #ccc;padding:8px;text-align:left} th{background:#f5f5f5}</style></head><body>${bodyHtml}</body></html>`;
                const w = window.open("", "_blank");
                if (!w) {
                    toast({
                        position: "top",
                        title: "Print",
                        description: "Allow pop-ups for this site to open the print window.",
                        status: "warning",
                        duration: 4000,
                        isClosable: true,
                    });
                } else {
                    w.document.open();
                    w.document.write(doc);
                    w.document.close();
                    w.focus();
                    w.print();
                    w.close();
                }
                setRefreshOrderHistory((prev) => !prev);
            } finally {
                setIsStripeDetailsPrinting(false);
            }
        };

        const handleConfirmReorder = async (data: { poNumber: string; roNumber: string; useAdmin: number }) => {
            if (!selectedOrderForReorder) return;

            setIsLoading(true);
            setReorderModalOpen(false);

            // Определяем userId: если useAdmin = true, используем null или userId администратора
            // Если useAdmin = false, используем userId текущего пользователя
            orderController.reorder({
                data: {
                    id: selectedOrderForReorder.id,
                    poNumber: data.poNumber || null,
                    namePo: data.roNumber || null,
                    userId: data.useAdmin
                }
            }).then((res) => {
                setIsLoading(false);
                toast({
                    position: "top",
                    title: res.None ? 'Failed reorder: ' + selectedOrderForReorder.id : 'Reorder success id: ' + res.Some.id,
                    status: res.None ? 'error' : 'success',
                    duration: 3000,
                    isClosable: true,
                })
                setRefreshOrderHistory(prevIndex => !prevIndex);
                setSelectedOrderForReorder(null);
            }).catch((error) => {
                setIsLoading(false);
                toast({
                    position: "top",
                    title: 'Failed reorder: ' + selectedOrderForReorder.id,
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                });
                setSelectedOrderForReorder(null);
            });
        };

        const downloadInvoice = (order?: Order) => {
            const reqConfig = buildFilters(order);
            orderController.invoicePdf(reqConfig).then(res => {
                if (!res.None) {
                    const blob = new Blob([res.Some], {type: 'application/pdf'});
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(blob);
                    // downloadLink.download = `invoice-#${reqConfig.data["entityIds"].length > 1 ? 'combinated' : reqConfig.data["entityIds"][0].id}.pdf`;
                    downloadLink.download = `invoice-#${order ? order?.id : 'combinated'}.pdf`;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
                setSelectedItems([]);
            });
        }
        const [isConfirmPayment, setIsConfirmPayment] = useState(false);
        const confirmPayment = (order?: Order, currentState?: OrderTypes) => {
            const reqConfig = buildFilters(order);
            if (currentState !== OrderTypes.FREE) {
                reqConfig.params["state"] = getNextStageTargetStatus(currentState);
            } else {
                reqConfig.params["state"] = currentState
            }
            modalService.setModalData({
                onSubmit: () => {
                    modalService.deleteModalData();
                    if (!order) {
                        setIsConfirmPayment(true);
                    }
                    orderController.orderConfirmState(reqConfig).then((res) => {
                        if (res && (res.None || res.Some === false)) {
                            const msg = res?.None?.message || res?.None?.toString?.() || "Request rejected";
                            toast({
                                position: "top",
                                title: "Status change failed",
                                description: msg,
                                status: "error",
                                duration: 5000,
                                isClosable: true,
                            });
                        } else {
                            setSelectedItems([]);
                            setRefreshOrderHistory(prevIndex => !prevIndex);
                        }
                        setIsConfirmPayment(false);
                    });
                },
                isOpen: true,
                onOpen: () => {
                },
                onClose: () => {
                    modalService.deleteModalData();
                },
                modalTextData: `Are you sure that you want to change status ${order ? order.id : countSelected} invoice ?`,
                context: "action"
            });
        };
        /** Для DownloadButton в модалке поставщиков — возвращает Option с blob */
        const downloadOrderXlsForVendor = async (vendor: boolean, userId?: number, summaryOnly?: boolean) => {
            const reqConfig = buildFilters();
            if (!reqConfig || !user) {
                return {Some: [], None: {message: "Session required"} as any};
            }
            reqConfig.data["vendor"] = vendor;
            reqConfig.data["vendorId"] = userId;
            if (summaryOnly) {
                return await DownloaderInstance.getVendorProductOrderCountXls(reqConfig);
            }
            return await DownloaderInstance.getOrderListXls(reqConfig);
        };

        const downloadFunc = async (vendor: boolean, userId?: number, summaryOnly?: boolean) => {
            try {
                const res = await downloadOrderXlsForVendor(vendor, userId, summaryOnly);
                if (res?.None) {
                    toast({
                        position: "top",
                        title: "Error upload File",
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                    return;
                }
                const nameFile = summaryOnly
                    ? "vendor-product-order-count.xlsx"
                    : vendor
                        ? "vendor-statement.xlsx"
                        : "statement.xlsx";
                fileDownload(res.Some, nameFile);
            } catch {
                toast({
                    position: "top",
                    title: "Error during file download",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                });
            }
        };


        const handlePrintPressed = (type: DocumentTypes, order?: Order) => {
            if (type === DocumentTypes.Invoice) {
                orderController.printPressed(buildFilters(order)).then(() => {
                    setRefreshOrderHistory(prevIndex => !prevIndex);
                })
            } else {
                setRefreshOrderHistory(prevIndex => !prevIndex);
            }
            setGroupOrder(order)
            setIsDocumentType(type)
            setPdf(order ? order.id : 1)
            setIsPrint(true)
        };

        const [isSendInvoice, setIsSendInvoice] = useState(false);

        const handleSendInvoice = (order?: Order, flagReminder?: boolean) => {
            if (!order && !id) {
                setOrdersToSend(selectedItems);
                setIsSendModalOpen(true);
                return;
            }
            const reqConfig = buildFilters(order);
            reqConfig.data["reminder"] = !!flagReminder;

            if (order && order.paymentStatus !== OrderTypes.CARD_PAID && (order.printPressed ?? 0) === 0) {
                toast({
                    position: "top",
                    title: 'Error sending invoice. The invoice must be printed at least once.',
                    status: 'error',
                    duration: 4000,
                    isClosable: true,
                })
                return;
            }
            if (!!flagReminder) {
                modalService.setModalData({
                    onSubmit: () => {
                        modalService.deleteModalData();
                        if (!order) {
                            setIsSendInvoice(true);
                        } else {
                            setLoadingReminderInvoiceOrderId(order.id);
                        }
                        orderController.sendInvoice(reqConfig).then((res) => {
                            toast({
                                position: "top",
                                title: res.None ? 'Failed to send' : order
                                    ? `Invoice #${order?.id} has been sent as a reminder successfully`
                                    : `${countSelected} selected invoices have been sent as reminders successfully`,
                                status: res.None ? 'error' : 'success',
                                duration: 4000,
                                isClosable: true,
                            })
                            setLoadingInvoiceOrderId(null);
                            setLoadingReminderInvoiceOrderId(null);
                            setIsSendInvoice(false);
                            setSelectedItems([]);
                            setRefreshOrderHistory(prevIndex => !prevIndex);
                        })
                    },
                    isOpen: true,
                    onOpen: () => {
                    },
                    onClose: () => {
                        modalService.deleteModalData();
                    },
                    modalTextData: <Text whiteSpace="pre-wrap" wordBreak="break-word">
                        {order
                            ? `email to: ${order?.dealership?.email}?`
                            : `email to: ${countSelected} selected invoices?`}
                    </Text>,
                    context: "action"
                });

            } else {
                if (!order) {
                    setIsSendInvoice(true);
                } else {
                    setLoadingInvoiceOrderId(order.id);
                }
                orderController.sendInvoice(reqConfig).then((res) => {
                    toast({
                        position: "top",
                        title: res.None ? 'Failed to send' : order
                            ? `Invoice #${order?.id} has been sent successfully`
                            : `${countSelected} selected invoices have been sent successfully`,
                        status: res.None ? 'error' : 'success',
                        duration: 4000,
                        isClosable: true,
                    })
                    setLoadingInvoiceOrderId(null);
                    setLoadingReminderInvoiceOrderId(null);
                    setIsSendInvoice(false);
                    setPdf(0)
                    setSelectedItems([]);
                    setRefreshOrderHistory(prevIndex => !prevIndex);
                })
            }
        };

        const showInvoice = (order?: Order) => {
            setIsDocumentType(DocumentTypes.Invoice)
            setIsPrint(false)
            setGroupOrder(order)
            setPdf(order ? order.id : 1)
        }

        // Функция для закрытия модального окна отправки
        const handleCloseSendModal = () => {
            setIsSendModalOpen(false);
            setOrdersToSend([]);
            setPdf(0)
            setSelectedItems([]);
        };

        // Функция для обработки успешной отправки
        const handleSendSuccess = () => {
            setSelectedItems([]);
            setRefreshOrderHistory(prev => !prev);
        };

        const statusFilterOptions = [{id: -1, name: ""},
            {id: 0, name: getOrderState(0, !hasPermission(orderEditPermission)).name},
            {id: 1, name: getOrderState(1, !hasPermission(orderEditPermission)).name},
            {id: 2, name: getOrderState(2, !hasPermission(orderEditPermission)).name},
            {id: 3, name: getOrderState(3, !hasPermission(orderEditPermission)).name},
            {id: 5, name: getOrderState(5, !hasPermission(orderEditPermission)).name},
            {id: 6, name: getOrderState(6, !hasPermission(orderEditPermission)).name}
        ];
        const sortLabels: Record<string, string> = {
            date: "Date",
            order: "Order",
            qnt: "Qnt",
            user: "User",
            dealership: "Dealership",
            status: "Status",
            amount: "Amount",
        };
        const desktopTableMinWidth = "100%";
        /** Узкая колонка под одно меню «⋯»; в legacy — ширина под набор иконок. */
        const actionsColumnWidth = showColumnHeaderFunnels ? 170 : 70;
        const showQntColumn = hasPermission(orderAmountShowPermission);
        const showDealershipColumn = hasPermission(orderDealershipShowPermission);
        const showStatusColumn = hasPermission(orderStatusShowPermission);
        const showAmountColumn = hasPermission(orderAmountShowPermission);
        const minDesktopColumnWidths = useMemo(() => ({
            date: 130,
            order: 70,
            ...(showQntColumn ? {qnt: 56} : {}),
            user: 120,
            ...(showDealershipColumn ? {dealership: 220} : {}),
            ...(showStatusColumn ? {status: 90} : {}),
            ...(showAmountColumn ? {amount: 80} : {}),
            actions: actionsColumnWidth,
        }), [actionsColumnWidth, showAmountColumn, showDealershipColumn, showQntColumn, showStatusColumn]);
        const defaultDesktopColumnWidths = useMemo(() => ({
            date: Math.max(150, minDesktopColumnWidths.date),
            order: Math.max(105, minDesktopColumnWidths.order),
            ...(showQntColumn ? {qnt: Math.max(60, minDesktopColumnWidths.qnt || 56)} : {}),
            user: Math.max(150, minDesktopColumnWidths.user),
            ...(showDealershipColumn ? {dealership: Math.max(250, minDesktopColumnWidths.dealership || 95)} : {}),
            ...(showStatusColumn ? {status: Math.max(150, minDesktopColumnWidths.status || 130)} : {}),
            ...(showAmountColumn ? {amount: Math.max(120, minDesktopColumnWidths.amount || 60)} : {}),
            actions: actionsColumnWidth,
        }), [actionsColumnWidth, minDesktopColumnWidths, showAmountColumn, showDealershipColumn, showQntColumn, showStatusColumn]);
        const [desktopColumnWidths, setDesktopColumnWidths] = useState<Record<string, number>>(defaultDesktopColumnWidths);

        const tanstackColumns: ColumnDef<Order, any>[] = useMemo(() => ([
            {id: "date", header: "DATE", accessorFn: (row) => row.createdAt},
            {id: "order", header: "ORDER", accessorFn: (row) => row.id},
            ...(showQntColumn ? [{id: "qnt", header: "QNT", accessorFn: (row: Order) => row.products?.length || 0}] : []),
            {id: "user", header: "USER", accessorFn: (row) => row.user?.name},
            ...(showDealershipColumn ? [{
                id: "dealership",
                header: "DEALERSHIP",
                accessorFn: (row: Order) => row.dealership?.name
            }] : []),
            ...(showStatusColumn ? [{id: "status", header: "STATUS", accessorFn: (row: Order) => row.paymentStatus}] : []),
            ...(showAmountColumn ? [{id: "amount", header: "AMOUNT", accessorFn: (row: Order) => row.totalAmount}] : []),
            {id: "actions", header: "ACTION", accessorFn: (row) => row.id},
        ]), [showAmountColumn, showDealershipColumn, showQntColumn, showStatusColumn]);
        const tanstackData = useMemo<Order[]>(() => orderClientList?.orders || [], [orderClientList?.orders]);
        const isCardPaidFilterActive = useMemo(
            () =>
                columnFilters.some(
                    (f) => f.id === "status" && String(f.value) === String(OrderTypes.CARD_PAID),
                ),
            [columnFilters],
        );
        const handleCardPaidFilterClick = useCallback(() => {
            const cardPaidId = String(OrderTypes.CARD_PAID);
            setColumnFilters((prev) => {
                const cur = prev.find((f) => f.id === "status");
                if (cur && String(cur.value) === cardPaidId) {
                    return prev.filter((f) => f.id !== "status");
                }
                const rest = prev.filter((f) => f.id !== "status");
                return [...rest, {id: "status", value: cardPaidId}];
            });
            setCurrentPaginatorPosition(0);
        }, []);
        const tanstackTable = useReactTable({
            data: tanstackData,
            columns: tanstackColumns,
            state: {sorting, columnFilters},
            onSortingChange: setSorting,
            onColumnFiltersChange: setColumnFilters,
            manualSorting: true,
            manualFiltering: true,
            getCoreRowModel: getCoreRowModel(),
        });
        const desktopColumnIds = tanstackColumns.map((col: any) => String(col.id));
        const desktopGridTemplate = desktopColumnIds
            .map((id) => {
                if (id === "actions") return `${actionsColumnWidth}px`;
                const minWidth = minDesktopColumnWidths[id] ?? 56;
                const safeWidth = Math.max(minWidth, desktopColumnWidths[id] ?? defaultDesktopColumnWidths[id] ?? 100);
                return `minmax(${minWidth}px, ${safeWidth}fr)`;
            })
            .join(" ");
        const desktopRowsFromTable = tanstackTable.getRowModel().rows.map((row) => row.original);
        const resizingRef = useRef<{
            id: string;
            rightColumnIds: string[];
            startX: number;
            startWidth: number;
            startRightWidths: Record<string, number>;
        } | null>(null);

        useEffect(() => {
            setDesktopColumnWidths((prev) => ({...defaultDesktopColumnWidths, ...prev, actions: actionsColumnWidth}));
        }, [actionsColumnWidth, defaultDesktopColumnWidths]);

        const handleResizeMouseDown = (columnId: string, e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            const columnIndex = desktopColumnIds.indexOf(columnId);
            if (columnIndex < 0 || columnIndex >= desktopColumnIds.length - 1) return;
            if (columnId === "actions") return;
            const rightColumnIds = desktopColumnIds
                .slice(columnIndex + 1)
                .filter((id) => id !== "actions");
            if (rightColumnIds.length === 0) return;
            const measuredWidths: Record<string, number> = {};
            const headerGrid = (e.currentTarget as HTMLElement).closest("[data-desktop-header-grid='true']");
            if (headerGrid) {
                const cells = headerGrid.querySelectorAll<HTMLElement>("[data-column-id]");
                cells.forEach((cell) => {
                    const id = cell.dataset.columnId;
                    if (id) {
                        measuredWidths[id] = Math.round(cell.getBoundingClientRect().width);
                    }
                });
            }
            const currentWidth = measuredWidths[columnId]
                ?? desktopColumnWidths[columnId]
                ?? defaultDesktopColumnWidths[columnId]
                ?? 100;
            const startRightWidths = rightColumnIds.reduce<Record<string, number>>((acc, id) => {
                acc[id] = measuredWidths[id] ?? desktopColumnWidths[id] ?? defaultDesktopColumnWidths[id] ?? 100;
                return acc;
            }, {});
            resizingRef.current = {
                id: columnId,
                rightColumnIds,
                startX: e.clientX,
                startWidth: currentWidth,
                startRightWidths,
            };

            const onMouseMove = (moveEvent: MouseEvent) => {
                if (!resizingRef.current) return;
                const delta = moveEvent.clientX - resizingRef.current.startX;
                const minCurrentWidth = minDesktopColumnWidths[resizingRef.current.id] ?? 56;
                const maxShrinkByCurrent = resizingRef.current.startWidth - minCurrentWidth;
                const rightColumns = resizingRef.current.rightColumnIds;
                const maxGrowByRight = rightColumns.reduce((sum, id) => {
                    const minWidth = minDesktopColumnWidths[id] ?? 56;
                    const startWidth = resizingRef.current!.startRightWidths[id] ?? 100;
                    return sum + Math.max(0, startWidth - minWidth);
                }, 0);
                const clampedDelta = Math.max(-maxShrinkByCurrent, Math.min(delta, maxGrowByRight));
                const nextCurrentWidth = resizingRef.current.startWidth + clampedDelta;
                const nextRightWidths: Record<string, number> = {...resizingRef.current.startRightWidths};

                if (clampedDelta > 0) {
                    // Grow current column by shrinking right-side columns one by one to their mins.
                    let remaining = clampedDelta;
                    rightColumns.forEach((id) => {
                        const minWidth = minDesktopColumnWidths[id] ?? 56;
                        const startWidth = resizingRef.current!.startRightWidths[id] ?? 100;
                        const shrinkCapacity = Math.max(0, startWidth - minWidth);
                        const shrinkBy = Math.min(remaining, shrinkCapacity);
                        nextRightWidths[id] = startWidth - shrinkBy;
                        remaining -= shrinkBy;
                    });
                } else if (clampedDelta < 0) {
                    // Shrink current column and give freed space to the nearest right column.
                    const nearestId = rightColumns[0];
                    if (nearestId) {
                        nextRightWidths[nearestId] = (resizingRef.current.startRightWidths[nearestId] ?? 100) - clampedDelta;
                    }
                }

                setDesktopColumnWidths((prev) => {
                    const next = {...prev, [resizingRef.current!.id]: nextCurrentWidth};
                    rightColumns.forEach((id) => {
                        if (nextRightWidths[id] != null) {
                            next[id] = nextRightWidths[id];
                        }
                    });
                    return next;
                });
            };

            const onMouseUp = () => {
                resizingRef.current = null;
                window.removeEventListener("mousemove", onMouseMove);
                window.removeEventListener("mouseup", onMouseUp);
            };

            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("mouseup", onMouseUp);
        };
        const currentSortLabel = sorting.length > 0
            ? `${sortLabels[sorting[0].id] || sorting[0].id} (${sorting[0].desc ? "DESC" : "ASC"})`
            : "No sort";
        const cycleColumnSort = (columnId: string) => {
            if (columnId !== "qnt") return;
            setSorting((prev) => {
                const current = prev[0];
                if (!current || current.id !== columnId) {
                    return [{id: columnId, desc: false}];
                }
                if (current.desc === false) {
                    return [{id: columnId, desc: true}];
                }
                return [];
            });
        };
        const dealershipSuggestions = useMemo<string[]>(() => {
            const fromMinInfo = dealershipsMinInfo.map((d: DealershipMinInfo) => d.name);
            const fromUser = (user?.dealerships || []).map((d) => d.name);
            return Array.from(new Set([...fromMinInfo, ...fromUser].filter(Boolean))).sort((a, b) => a.localeCompare(b));
        }, [dealershipsMinInfo, user?.dealerships]);
        const renderDesktopHeader = (): any => {
            const headerGroups = tanstackTable.getHeaderGroups() as any[];
            const canShowColumnFilter = (columnId: string): boolean =>
                ["date", "order", "user", "dealership", "status", "amount"].includes(columnId);
            return headerGroups.map((headerGroup: any) => (
                <Grid
                    key={headerGroup.id}
                    data-desktop-header-grid="true"
                    templateColumns={desktopGridTemplate}
                    width="100%"
                    alignItems="center"
                    columnGap={0}
                    px={2}
                    py={2}
                    fontSize="14px"
                    fontWeight="700"
                    bg="aliceblue"
                    whiteSpace="nowrap"
                    sx={{
                        "& > *": {px: 2},
                        "& > *:not(:last-child)": {borderRight: "1px solid", borderColor: "gray.200"},
                    }}
                >
                    {(headerGroup.headers as any[]).map((header: any) => {
                        const label = String(header.column.columnDef.header ?? "");
                        const columnId = String(header.column.id);
                        const isQntSortable = String(header.column.id) === "qnt";
                        const isSorted = sorting.find((s) => s.id === header.column.id);
                        return (
                            <Box key={header.id}
                                 data-column-id={String(header.column.id)}
                                 position="relative"
                                 cursor={isQntSortable ? "pointer" : "default"}
                                 textAlign={label === "INVOICE" ? "center" : "left"}
                                 onClick={() => {
                                     if (!isQntSortable) return;
                                     cycleColumnSort(header.column.id);
                                 }}>
                                <Flex align="center" gap={1}>
                                    <Text userSelect="none">
                                        {flexRender(header.column.columnDef.header, header.getContext())}
                                        {isSorted ? (isSorted.desc ? " ▼" : " ▲") : ""}
                                    </Text>
                                    {canShowColumnFilter(columnId) && showColumnHeaderFunnels && (
                                        <Box
                                            as="button"
                                            type="button"
                                            aria-label={`Filter ${columnId}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onHeaderFilterClickRef.current(e, columnId);
                                            }}
                                            lineHeight={0}
                                            cursor="pointer"
                                        >
                                            <Icon as={FiFilter} boxSize={3.5}
                                                  color={getFilterIconColorRef.current(columnId)}/>
                                        </Box>
                                    )}
                                </Flex>
                                {label !== "INVOICE" && header.column.id !== "actions" && (
                                    <Box
                                        position="absolute"
                                        top={0}
                                        right={-1}
                                        width="6px"
                                        height="100%"
                                        cursor="col-resize"
                                        onMouseDown={(e) => handleResizeMouseDown(String(header.column.id), e)}
                                        _hover={{bg: "gray.300"}}
                                    />
                                )}
                            </Box>
                        );
                    })}
                </Grid>
            ));
        };

        const confirmRemove = (id: number) => {
            modalService.setModalData({
                onSubmit: () => {
                    modalService.deleteModalData();
                    orderController.removeOrder(id).then((res) => {
                        toast({
                            position: "top",
                            title: res.None ? 'Failed removed id: ' + id : 'Order removed id: ' + id,
                            status: res.None ? 'error' : 'success',
                            duration: 3000,
                            isClosable: true,
                        })
                        setRefreshOrderHistory(prevIndex => !prevIndex);
                    })
                },
                isOpen: true,
                onOpen: () => {
                },
                onClose: () => {
                    modalService.deleteModalData();
                },
                modalTextData: "Do you sure remove order",
                context: "action"
            });
        };

        /** Admin Card paid: teal if invoice printed and sent, summary not printed; otherwise pink (like In). */
        function getCardPaidAdminRowColor(order: Order): string {
            const summaryPrinted = (order.cardPaymentDetailsPrintCount ?? 0) > 0;
            const invoicePrinted = (order.printPressed ?? 0) > 0;
            const invoiceSent = (order.sendCount ?? 0) > 0;
            if (invoicePrinted && invoiceSent && !summaryPrinted) {
                return "teal.100";
            }
            return "lightpink";
        }

        function getOrderRowBackgroundColor(order: Order): string {
            const status =
                order.tbd && isInLike(order.paymentStatus) ? OrderTypes.TBD : order.paymentStatus;
            if (status === OrderTypes.CARD_PAID && hasPermission(orderEditPermission)) {
                return getCardPaidAdminRowColor(order);
            }
            return getOrderState(status).color;
        }

        function getOrderState(paymentStatus: OrderTypes, userStatus?: boolean): any {
            switch (paymentStatus) {
                case OrderTypes.IN:
                    return {name: userStatus ? "Received" : "In", color: "lightpink"}
                case OrderTypes.CARD_PAID:
                    return {name: "Card paid", color: "teal.100"}
                case OrderTypes.REFUND:
                    return {name: "Refund", color: "orange.100"}
                case OrderTypes.PENDING:
                    return {name: "Unpaid", color: "lightgoldenrodyellow"}
                case OrderTypes.PAID:
                    return {name: "Paid", color: "unset"}
                case OrderTypes.FREE:
                    return {name: "Free", color: "lightblue"}
                case OrderTypes.TBD:
                    return {name: "Tbd", color: "purple.300"}
                default:
                    return {name: "Undef", color: "unset"}
            }
        }

        function isInLike(status?: OrderTypes): boolean {
            return status === OrderTypes.IN || status === OrderTypes.CARD_PAID;
        }

        /** Куда ведёт «следующий этап»: In → Unpaid, Card paid → Paid, Pending → Paid, … */
        function getNextStageTargetStatus(currentState?: OrderTypes): OrderTypes {
            if (currentState === OrderTypes.IN) return OrderTypes.PENDING;
            if (currentState === OrderTypes.CARD_PAID) return OrderTypes.PAID;
            if (currentState === undefined || currentState === null) {
                return OrderTypes.PAID;
            }
            return isInLike(currentState) ? OrderTypes.PENDING : OrderTypes.PAID;
        }

        function getNextStageTargetDisplayName(currentState?: OrderTypes, userStatus?: boolean): string {
            return getOrderState(getNextStageTargetStatus(currentState), userStatus).name;
        }

        const parseDateString = (dateString: any) => {
            const parsedDate = parse(dateString, 'MM.dd.yyyy HH:mm', new Date());
            if (!parsedDate) {
                throw new RangeError('Invalid time value');
            }
            return parsedDate;
        };


        const handleOnclickNew = (elem: any, remove: Boolean) => {
            setSelectedItems(prevSelectedItems => {
                const isSelected = prevSelectedItems.some(item => item.id === elem.id);
                if (isSelected) {
                    return remove ? prevSelectedItems.filter(item => item.id !== elem.id) : prevSelectedItems;
                } else {
                    return [...prevSelectedItems, elem];
                }
            });
        };

        const canPayInvoiceOnline = (elem: Order): boolean =>
            !isRoleAdmin() &&
            !hasPermission(orderEditPermission) &&
            elem.paymentType === PaymentTypes.INVOICE &&
            !elem.tbd &&
            (isInLike(elem.paymentStatus) || elem.paymentStatus === OrderTypes.PENDING) &&
            !elem.isDeleted &&
            isUserAllowedCardPayment(user);
        const canShowAdminPaymentDetails = (elem: Order): boolean =>
            hasPermission(orderEditPermission) &&
            elem.paymentType === PaymentTypes.CARD &&
            !!elem.stripeTransactionId;

        const renderUnifiedPaymentIcon = (elem: Order) =>
            (canPayInvoiceOnline(elem) || canShowAdminPaymentDetails(elem)) ? (
                <Box ml="auto" pl={{base: 3, md: 4}} flexShrink={0} display="inline-flex" alignItems="center">
                    {(() => {
                        const isPayAction = canPayInvoiceOnline(elem);
                        return (
                            <Flex alignItems="center" gap={1}>
                                {isPayAction && (
                                    <Badge
                                        colorScheme="orange"
                                        variant="subtle"
                                        borderRadius="full"
                                        fontSize="10px"
                                        mr={1}
                                        px={1.5}
                                        py={0.5}
                                        cursor="pointer"
                                        onClick={() => setPayInvoiceOrder(elem)}
                                    >
                                        Pay by Card
                                    </Badge>
                                )}
                                <Text
                                    as="span"
                                    cursor="pointer"
                                    fontSize="14px"
                                    lineHeight="1"
                                    userSelect="none"
                                    aria-label={canPayInvoiceOnline(elem) ? "Pay with credit card" : "Details"}
                                    title={canPayInvoiceOnline(elem) ? "Pay with credit card" : "Details"}
                                    onClick={() => {
                                        if (canPayInvoiceOnline(elem)) {
                                            setPayInvoiceOrder(elem);
                                            return;
                                        }
                                        handleShowPaymentIntent(elem);
                                    }}
                                >
                                    💳
                                </Text>

                            </Flex>
                        );
                    })()}
                </Box>
            ) : null;

        const MenuButtonAny: any = MenuButton;

        const hasGroupSelection =
            (selectedItems && selectedItems.length > 1) || isExcluded === "2";
        const canUseGroupActions = hasGroupSelection;
        const showToolbarActionMenu =
            hasPermission(orderEditPermission) || (hasGroupSelection && canUseGroupActions);
        const hasToolbarExportSection = hasPermission(orderEditPermission);
        const hasToolbarBulkInvoiceSection = hasGroupSelection && canUseGroupActions;
        const hasToolbarNextStageSection = hasGroupSelection && hasPermission(orderEditPermission);
        const orderHistoryActionMenu: OrderHistoryActionMenuConfig | undefined = showToolbarActionMenu
            ? {
                hasExportSection: hasToolbarExportSection,
                hasBulkInvoiceSection: hasToolbarBulkInvoiceSection,
                hasNextStageSection: hasToolbarNextStageSection,
                showInvoiceMenuItem: !isMobile,
                canPrintSelect: hasPermission(orderEditPermission),
                canSendSelect: hasPermission(orderEditPermission),
                sendSelectDisabled: isSendInvoice && !!id,
                nextStageDisabled: isConfirmPayment,
                onExportStatement: () => downloadFunc(false),
                onExportSales: () => setIsVendorSalesModalOpen(true),
                onDownloadInvoice: () => downloadInvoice(),
                onShowInvoice: () => showInvoice(),
                onPrintSelect: () => handlePrintPressed(DocumentTypes.Invoice),
                onSendSelect: () => handleSendInvoice(),
                onBulkToPaid: () => confirmPayment(undefined, OrderTypes.PENDING),
            }
            : undefined;
        const orderRowMenuListSx = {".chakra-menu__menuitem": {py: 0.5, minH: "22px", fontSize: "12px"}};

        /** Старый вид строки: иконки в колонке ACTION (legacy UI фильтров). */
        const renderOrderActionIconRow = (elem: Order) => (
            <Flex flexWrap="wrap" justifyContent="flex-end" gap={1} onClick={(e) => e.stopPropagation()}>
                {hasPermission(orderEditPermission) && isInLike(elem.paymentStatus) && (
                    <Box onClick={() => handlePrintPressed(DocumentTypes.Invoice, elem)}>
                        <IconWithTooltip icon={FiPrinter} tooltipMessage={`Printed(${elem.printPressed})`}
                                         isOutlined={isInLike(elem.paymentStatus) && elem.printPressed === 0}/>
                    </Box>
                )}
                {(elem.paymentStatus !== OrderTypes.IN || hasPermission(orderViewPartnerPermission)) && (
                    <Box onClick={() => showInvoice(elem)}>
                        <IconWithTooltip icon={FiEye} tooltipMessage={'Show'}/>
                    </Box>
                )}
                {hasPermission(orderEditPermission) && (
                    <Box onClick={() => {
                        setLoadingInvoiceOrderId(elem.id);
                        handleSendInvoice(elem);
                        setTimeout(() => setLoadingInvoiceOrderId(null), 1000);
                    }}>
                        <IconWithTooltip icon={FiSend} tooltipMessage={`Send(${elem.sendCount})`}
                                         isLoading={loadingInvoiceOrderId === elem.id}
                                         isOutlined={isInLike(elem.paymentStatus) && (elem.sendCount ?? 0) === 0}/>
                    </Box>
                )}
                {(elem.paymentStatus !== OrderTypes.IN || hasPermission(orderViewPartnerPermission)) && (
                    <Box onClick={() => downloadInvoice(elem)}>
                        <IconWithTooltip icon={FiDownload} tooltipMessage={'Download'}/>
                    </Box>
                )}
                {hasPermission(orderEditPermission) && (
                    <Box onClick={() => handlePrintPressed(DocumentTypes.PackingSleep, elem)}>
                        <IconWithTooltip label={'PS'} tooltipMessage={'Packing Slip'}/>
                    </Box>
                )}
                {hasPermission(orderEditPermission) && (
                    <Box onClick={() => handleSendInvoice(elem, true)}>
                        <IconWithTooltip label={'IR'} tooltipMessage={'Invoice Reminder'} isLoading={loadingReminderOrderId === elem.id}/>
                    </Box>
                )}
                {hasPermission(orderEditPermission) && (
                    <Box onClick={() => handleReorderInvoice(elem)}>
                        <IconWithTooltip icon={FiCopy} tooltipMessage={'Reorder'}/>
                    </Box>
                )}
                {hasPermission(orderRemovePermission) && (
                    <Box onClick={() => confirmRemove(elem?.id)}>
                        <IconWithTooltip icon={FiTrash} tooltipMessage={'Remove'}/>
                    </Box>
                )}
            </Flex>
        );

        /** Новый вид: выпадающее меню в колонке ACTION (как до rollback «иконок»). */
        const renderOrderActionsMenuModern = (elem: Order) => (
            <Flex justifyContent="flex-end" onClick={(e) => e.stopPropagation()}>
                <Menu placement="bottom-end" gutter={4} strategy="fixed" closeOnSelect>
                    {/* @ts-ignore Chakra MenuButton union */}
                    <MenuButtonAny
                        as={IconButton}
                        aria-label="Order actions"
                        icon={<BsThreeDotsVertical size={15}/>}
                        size="sm"
                        variant="ghost"
                        border="none"
                        minW="unset"
                        w="22px"
                        h="22px"
                        p={0}
                        _hover={{bg: "transparent"}}
                        _active={{bg: "gray.100"}}
                        _focus={{boxShadow: "none"}}
                    />
                    <MenuList fontSize="sm" minW="220px" zIndex={1500} sx={orderRowMenuListSx}>
                        {hasPermission(orderDealershipShowPermission) && (
                            <MenuGroup title="DEALERSHIP">
                                <MenuItem
                                    icon={<FiTag/>}
                                    fontSize="sm"
                                    onClick={() => navigate(`${URLPaths.ALL_PRODUCTS_ORDER.link}${elem?.dealership?.id}`)}
                                >
                                    All Items Purchased
                                </MenuItem>
                                <MenuItem
                                    icon={<FiBriefcase/>}
                                    fontSize="sm"
                                    onClick={() => {
                                        setSelectedItems([]);
                                        handlePageChange(0);
                                        navigate(`${URLPaths.ORDER_HISTORY.link}/${elem?.dealership?.id}`);
                                    }}
                                >
                                    All Orders This Dealership
                                </MenuItem>
                            </MenuGroup>
                        )}
                        {((hasPermission(orderEditPermission) && (elem?.paymentStatus === OrderTypes.PENDING ||
                                (isInLike(elem?.paymentStatus) && (canRemoveInLikeAfterSend(elem) || hasPermission(orderRemovePermission)))))
                            || (hasPermission(orderEditPermission) && isInLike(elem?.paymentStatus))) && (
                            <MenuGroup title="NEXT STAGE">
                                {(hasPermission(orderEditPermission) && (
                                    elem?.paymentStatus === OrderTypes.PENDING ||
                                    (isInLike(elem?.paymentStatus) && (canRemoveInLikeAfterSend(elem) || hasPermission(orderRemovePermission)))
                                )) && (
                                    <MenuItem icon={<AngleDoubleRight/>} fontSize="sm"
                                              onClick={() => confirmPayment(elem, elem?.paymentStatus)}>
                                        To Paid
                                    </MenuItem>
                                )}
                                {(hasPermission(orderEditPermission) && isInLike(elem?.paymentStatus)) && (
                                    <MenuItem icon={<FiCornerRightUp/>} fontSize="sm"
                                              onClick={() => confirmPayment(elem, OrderTypes.FREE)}>
                                        To Free
                                    </MenuItem>
                                )}
                            </MenuGroup>
                        )}
                        <MenuGroup title="INVOICE">
                            {hasPermission(orderEditPermission) && isInLike(elem.paymentStatus) && (
                                <MenuItem icon={<FiPrinter/>} fontSize="sm"
                                          onClick={() => handlePrintPressed(DocumentTypes.Invoice, elem)}>
                                    {`Print Invoice (${elem.printPressed})`}
                                </MenuItem>
                            )}
                            {(elem.paymentStatus !== OrderTypes.IN || hasPermission(orderViewPartnerPermission)) && (
                                <MenuItem icon={<FiEye/>} fontSize="sm" onClick={() => showInvoice(elem)}>
                                    Show
                                </MenuItem>
                            )}
                            {hasPermission(orderEditPermission) && (
                                <MenuItem
                                    icon={<FiSend/>}
                                    fontSize="sm"
                                    onClick={() => {
                                        setLoadingInvoiceOrderId(elem.id);
                                        handleSendInvoice(elem);
                                        setTimeout(() => setLoadingInvoiceOrderId(null), 1000);
                                    }}
                                    isDisabled={loadingInvoiceOrderId === elem.id}
                                >
                                    {loadingInvoiceOrderId === elem.id ? "Sending..." : `Send (${elem.sendCount})`}
                                </MenuItem>
                            )}
                            {(elem.paymentStatus !== OrderTypes.IN || hasPermission(orderViewPartnerPermission)) && (
                                <MenuItem icon={<FiDownload/>} fontSize="sm" onClick={() => downloadInvoice(elem)}>
                                    Download
                                </MenuItem>
                            )}
                            {hasPermission(orderEditPermission) && (
                                <MenuItem icon={<FiPrinter/>}
                                          fontSize="sm"
                                          onClick={() => handlePrintPressed(DocumentTypes.PackingSleep, elem)}>
                                    Packing Slip
                                </MenuItem>
                            )}
                            {hasPermission(orderEditPermission) && (
                                <MenuItem
                                    icon={<FiSend/>}
                                    fontSize="sm"
                                    onClick={() => handleSendInvoice(elem, true)}
                                    isDisabled={loadingReminderOrderId === elem.id}
                                >
                                    {loadingReminderOrderId === elem.id ? "Sending reminder..." : "Invoice Reminder"}
                                </MenuItem>
                            )}
                            {hasPermission(orderEditPermission) && (
                                <MenuItem icon={<FiCopy/>} fontSize="sm" onClick={() => handleReorderInvoice(elem)}>
                                    Reorder
                                </MenuItem>
                            )}
                            {hasPermission(orderRemovePermission) && (
                                <MenuItem icon={<FiTrash/>} fontSize="sm" color="red.600"
                                          onClick={() => confirmRemove(elem?.id)}>
                                    Remove
                                </MenuItem>
                            )}
                        </MenuGroup>
                        {hasPermission(orderEditPermission) && elem.paymentType === PaymentTypes.CARD && elem.stripeTransactionId && (
                            <MenuGroup title="PAYMENTS CARD">
                                <MenuItem icon={<FiCornerLeftDown/>} fontSize="sm"
                                          onClick={() => handleShowPaymentIntent(elem)}>
                                    Payment details / refund
                                </MenuItem>
                            </MenuGroup>
                        )}
                    </MenuList>
                </Menu>
            </Flex>
        );

        const renderOrderRowActions = (elem: Order) =>
            showColumnHeaderFunnels ? renderOrderActionIconRow(elem) : renderOrderActionsMenuModern(elem);

        const renderAmountWithRefund = (elem: Order, withDollarSign: boolean = false) => {
            const refundedAmountValue = Number(elem?.refundedAmount || 0);
            const feeValue = Number(elem?.fee || 0);
            const refundedMinusFee = Math.max(refundedAmountValue - feeValue, 0);
            const amountText = withDollarSign ? `$${elem?.totalAmount}` : `${elem?.totalAmount}`;
            const refundedText = withDollarSign
                ? ` - $${refundedMinusFee.toFixed(2)}`
                : ` - ${refundedMinusFee.toFixed(2)}`;
            const feeText = withDollarSign
                ? ` + $${feeValue.toFixed(2)}`
                : ` + ${feeValue.toFixed(2)}`;

            return (
                <Flex alignItems="center" justifyContent="flex-start" flexWrap="wrap" gap={1}>
                    <Text>{amountText}</Text>
                    {feeValue > 0 && refundedAmountValue <= 0 && (
                        <Text color="purple.500" fontWeight="500">{feeText}</Text>
                    )}
                    {refundedMinusFee > 0 && (
                        <Text color="red.500">{refundedText}</Text>
                    )}
                </Flex>
            );
        };

        const rowsSource = isMobile ? (orderClientList?.orders || []) : desktopRowsFromTable;
        const renderMobileFilterTrigger = (label: string, columnId: string) => (
            <Flex key={columnId} align="center" gap={1}>
                <Text>{label}</Text>
                {showColumnHeaderFunnels && (
                    <Box
                        as="button"
                        type="button"
                        aria-label={`Filter ${columnId}`}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onHeaderFilterClickRef.current(e, columnId);
                        }}
                        lineHeight={0}
                    >
                        <Icon as={FiFilter} boxSize={3.5} color={getFilterIconColorRef.current(columnId)}/>
                    </Box>
                )}
            </Flex>
        );
        const renderMobileHeader = () => (
            <Box bg="aliceblue" px={3} py={2} borderRadius="md" mb={2}>
                <Flex justifyContent="space-between" fontSize="11px" fontWeight="700" color="gray.700" gap={2}>
                    <Flex width="65%" wrap="wrap" columnGap={3} rowGap={1}>
                        {renderMobileFilterTrigger("DATE", "date")}
                        {renderMobileFilterTrigger("ORDER", "order")}
                        {showStatusColumn && renderMobileFilterTrigger("STATUS", "status")}
                        {showAmountColumn && renderMobileFilterTrigger("AMOUNT", "amount")}
                    </Flex>
                    <Flex width="35%" justifyContent="flex-end" wrap="wrap" columnGap={3} rowGap={1}>
                        {renderMobileFilterTrigger("USER", "user")}
                        {showDealershipColumn && renderMobileFilterTrigger("DEALERSHIP", "dealership")}
                        {/*<Text>ACTIONS</Text>*/}
                    </Flex>
                </Flex>
            </Box>
        );
        const ListAll = rowsSource.length > 0
            ? rowsSource.map((elem: Order, idx: number) => {
                let noShowPrepareIdOrder = (elem.paymentStatus === OrderTypes.IN && !(hasPermission(orderEditPermission) || hasPermission(orderIdShowPermission)))

                const ItemConfig: Array<ListProductItemConfig> = isMobile ? [
                    {
                        content:
                            <Flex width={"100%"} justifyContent={"space-between"}>
                                <Box width={"65%"}>
                                    <Flex justifyContent={"space-between"}>
                                        <Flex>
                                            <Checkbox font={"14px"} px={2}
                                                      icon={isExcluded === '2' ? <AiOutlineClose/> : undefined}
                                                      colorScheme={isExcluded === '2' ? 'red' : undefined}
                                                      isChecked={selectedItems.some(item => item.id === elem.id)}
                                                      onChange={() => {
                                                          handleOnclickNew(elem, selectedItems.some(item => item.id === elem.id))
                                                      }}
                                            />
                                            <Text>{format(parseDateString(elem?.createdAt), 'MM-dd-yyyy')}</Text>
                                        </Flex>
                                        <Box w={"40%"}>
                                            {noShowPrepareIdOrder ? (
                                                <Text
                                                    textDecoration="underline"
                                                    cursor="pointer"
                                                    _hover={{color: "gray.800", textDecoration: "unset"}}
                                                    onClick={() => navigate(`${URLPaths.ORDER_VIEW.link}${elem?.id}`)}
                                                >
                                                    order received
                                                </Text>
                                            ) : (
                                                <ShowOrderModal order={elem}/>
                                            )}
                                        </Box>
                                    </Flex>
                                    {(hasPermission(orderEditPermission) || hasPermission(dealershipExcludeSelectPermission)) ?
                                        <>
                                            <Text>
                                                {`${elem?.dealership?.name}${elem?.dealership?.localStatus ? ' ( L )' : ''}`}
                                            </Text>
                                            <Flex justifyContent={"space-between"}>
                                                <Flex alignItems="center" flexWrap="wrap" gap={2}>
                                                    <Text>
                                                        {getOrderState(elem.paymentStatus).name}
                                                    </Text>
                                                    {showColumnHeaderFunnels && (hasPermission(orderEditPermission) && (
                                                        elem?.paymentStatus === OrderTypes.PENDING ||
                                                        (isInLike(elem?.paymentStatus) && (canRemoveInLikeAfterSend(elem) || hasPermission(orderRemovePermission)))
                                                    )) && (
                                                        <IconWithTooltip icon={AngleDoubleRight}
                                                                         tooltipMessage={'Next stage ' + getNextStageTargetDisplayName(elem.paymentStatus)}
                                                                         onClick={() => confirmPayment(elem, elem?.paymentStatus)}/>
                                                    )}
                                                    {renderUnifiedPaymentIcon(elem)}
                                                </Flex>
                                                <Box w={"40%"}>
                                                    {hasPermission(orderAmountShowPermission) && (
                                                        renderAmountWithRefund(elem, true)
                                                    )}
                                                </Box>
                                            </Flex>
                                        </>
                                        :
                                        <Flex pl={1} alignItems="center" flexWrap="wrap" gap={2}>
                                            <Text>
                                                {getOrderState(elem.paymentStatus, true).name}
                                            </Text>
                                            {renderUnifiedPaymentIcon(elem)}
                                        </Flex>
                                    }
                                </Box>
                                <Box width={"35%"} display="flex" flexDirection="column" justifyContent="space-between">
                                    <Box ml={"auto"}>
                                        {hasPermission(orderAdminNameShowPermission) ? elem?.user?.id : elem?.user?.isAdmin ? "Manager" : elem?.user?.name}
                                    </Box>
                                    {(hasPermission(orderEditPermission) || hasPermission(dealershipExcludeSelectPermission)) &&
                                        showColumnHeaderFunnels && (
                                        <Flex ml={"auto"}>
                                            <IconWithTooltip icon={FiTag} tooltipMessage={'All Items Purchased'}
                                                             onClick={() => navigate(`${URLPaths.ALL_PRODUCTS_ORDER.link}${elem?.dealership?.id}`)}
                                            />
                                            <IconWithTooltip icon={FiBriefcase}
                                                             tooltipMessage={'All orders this dealership'}
                                                             onClick={() => {
                                                                 setSelectedItems([]);
                                                                 handlePageChange(0);
                                                                 navigate(`${URLPaths.ORDER_HISTORY.link}/${elem?.dealership?.id}`);
                                                             }}
                                            />
                                        </Flex>
                                    )}
                                    <Flex ml={"auto"}>
                                        {renderOrderRowActions(elem)}
                                    </Flex>
                                </Box>
                            </Flex>,
                        isLink: false,
                        width:
                            "100%",
                        justifyContent:
                            "flex-start"
                    }] : [{
                    content: (
                        <Grid
                            templateColumns={desktopGridTemplate}
                            alignItems="center"
                            columnGap={0}
                            width="100%"
                            px={2}
                            sx={{
                                "& > *": {px: 2},
                                "& > *:not(:last-child)": {borderRight: "1px solid", borderColor: "gray.100"},
                            }}
                        >
                            <Flex>
                                <Checkbox font={"14px"} px={2}
                                          icon={isExcluded === '2' ? <AiOutlineClose/> : undefined}
                                          colorScheme={isExcluded === '2' ? 'red' : undefined}
                                          isChecked={selectedItems.some(item => item.id === elem.id)}
                                          onChange={() => {
                                              handleOnclickNew(elem, selectedItems.some(item => item.id === elem.id))
                                          }}
                                />
                                <Text>{hasPermission(orderEditPermission) ? format(parseDateString(elem?.createdAt), 'MM-dd-yyyy') : elem?.createdAt}</Text>
                            </Flex>
                            <Box>
                                {noShowPrepareIdOrder ? <Text textDecoration={"underline"} cursor={"pointer"}
                                                              _hover={{color: "gray.800", textDecoration: "unset"}}
                                                              onClick={() => navigate(`${URLPaths.ORDER_VIEW.link}${elem?.id}`)}>{'order received'}</Text> :
                                    <ShowOrderModal order={elem}/>}
                            </Box>
                            {showQntColumn && (
                                <Box>
                                    {elem?.products.length === 1 ?
                                        <Tooltip label={`${elem?.products[0]?.product.name}`} placement="top">
                                            <Text cursor={"pointer"}>{elem?.products.length}</Text>
                                        </Tooltip>
                                        : elem?.products.length}
                                </Box>
                            )}
                            <Text>{hasPermission(orderAdminNameShowPermission) ? elem?.user?.name : elem?.user?.isAdmin ? "Manager" : elem?.user?.name}</Text>
                            {showDealershipColumn && (
                                <Flex alignItems="center">
                                    {showColumnHeaderFunnels && (
                                        <>
                                            <IconWithTooltip icon={FiTag} tooltipMessage={'All Items Purchased'}
                                                             onClick={() => navigate(`${URLPaths.ALL_PRODUCTS_ORDER.link}${elem?.dealership?.id}`)}
                                            />
                                            <IconWithTooltip icon={FiBriefcase} tooltipMessage={'All orders this dealership'}
                                                             onClick={() => {
                                                                 setSelectedItems([]);
                                                                 handlePageChange(0);
                                                                 navigate(`${URLPaths.ORDER_HISTORY.link}/${elem?.dealership?.id}`);
                                                             }}
                                            />
                                        </>
                                    )}
                                    {hasPermission(dealershipExcludeSelectPermission) ?
                                        <Text
                                            pl={2}>{elem?.dealership?.name}{elem?.dealership?.localStatus ? ' ( L )' : ''}</Text> :
                                        <Text pl={2} _hover={{color: "gray.800", textDecoration: "underline"}}
                                              cursor={'pointer'}
                                              onClick={() => setIdState({
                                                  companyId: elem?.dealership?.companyId,
                                                  dealershipId: elem?.dealership?.id
                                              })}>
                                            {elem?.dealership?.name}{elem?.dealership?.localStatus ? ' ( L )' : ''}
                                        </Text>}
                                </Flex>
                            )}
                            {showStatusColumn && (
                                <Flex alignItems="center" flexWrap="wrap" gap={2}>
                                    <Text>{getOrderState(elem.paymentStatus, !hasPermission(orderEditPermission)).name}</Text>
                                    {showColumnHeaderFunnels && (hasPermission(orderEditPermission) &&
                                        (elem?.paymentStatus === OrderTypes.PENDING ||
                                            (isInLike(elem?.paymentStatus) &&
                                                (canRemoveInLikeAfterSend(elem) || hasPermission(orderRemovePermission))))
                                    ) && (
                                        <IconWithTooltip icon={AngleDoubleRight}
                                                         tooltipMessage={'Next stage ' + getNextStageTargetDisplayName(elem.paymentStatus, !hasPermission(orderEditPermission))}
                                                         onClick={() => confirmPayment(elem, elem?.paymentStatus)}/>
                                    )}
                                    {showColumnHeaderFunnels && (hasPermission(orderEditPermission) && isInLike(elem?.paymentStatus)) && (
                                        <IconWithTooltip icon={FiCornerRightUp}
                                                         tooltipMessage={'Next stage free'}
                                                         onClick={() => confirmPayment(elem, OrderTypes.FREE)}/>
                                    )}
                                    {renderUnifiedPaymentIcon(elem)}
                                </Flex>
                            )}
                            {showAmountColumn && (
                                renderAmountWithRefund(elem)
                            )}
                            <Flex justifyContent="flex-end" pr={1}>{renderOrderRowActions(elem)}</Flex>
                        </Grid>
                    ),
                    isLink: false,
                    width: "100%",
                    justifyContent: "flex-start",
                }];
                return <ListProductItemRow key={idx} list={ItemConfig}
                                           style={{
                                               fontSize: "13px",
                                               minHeight: "35px",
                                               justifyContent: "flex-start",
                                               bgColor: hasPermission(orderEditPermission) ? getOrderRowBackgroundColor(elem) : 'unset'
                                           }}/>;
            })
            : null;


        return (
            <>
                {!account &&
                    <Breadcrumbs/>
                }
                {/* Модальное окно отслеживания отправки */}
                <InvoiceSendModal
                    isOpen={isSendModalOpen}
                    onClose={handleCloseSendModal}
                    orders={ordersToSend}
                    buildFilters={buildFilters}
                    flagReminder={flagReminder}
                    onSuccess={handleSendSuccess}
                    countSelected={countSelected}
                />

                <ReorderInvoiceModal
                    isOpen={reorderModalOpen}
                    onClose={() => {
                        setReorderModalOpen(false);
                        setSelectedOrderForReorder(null);
                    }}
                    order={selectedOrderForReorder}
                    onConfirm={handleConfirmReorder}
                />

                <LoadStatementVendorPopover
                    variant="modal"
                    isOpen={isVendorSalesModalOpen}
                    onClose={() => setIsVendorSalesModalOpen(false)}
                    clickAction={downloadOrderXlsForVendor}
                    item={{}}
                />

                <StripePaymentModal
                    isOpen={payInvoiceOrder !== null}
                    onClose={() => setPayInvoiceOrder(null)}
                    paymentContext="orderHistory"
                    amount={payInvoiceOrder?.totalAmount ?? 0}
                    currency="usd"
                    stripeKey={payInvoiceOrder?.id ?? "order-pay"}
                    onPaymentSuccess={() => {
                        setPayInvoiceOrder(null);
                        toast({
                            position: "top",
                            title: "Payment successful!",
                            description: "Your order has been updated.",
                            status: "success",
                            duration: 5000,
                            isClosable: true,
                        });
                        setRefreshOrderHistory((prev) => !prev);
                    }}
                    onPaymentError={(err: string) => {
                        setPayInvoiceOrder(null);
                        toast({
                            position: "top",
                            title: "Payment failed",
                            description: err,
                            status: "error",
                            duration: 5000,
                            isClosable: true,
                        });
                    }}
                    orderData={
                        payInvoiceOrder
                            ? {
                                orderId: String(payInvoiceOrder.id),
                                poNumber: payInvoiceOrder.poNumber ?? undefined,
                                namePo: payInvoiceOrder.namePo ?? undefined,
                                dealershipId: payInvoiceOrder.dealership?.id,
                                customerEmail: user?.email,
                                customerName: user?.login,
                                description: `Payment for order #${payInvoiceOrder.id}`,
                            }
                            : undefined
                    }
                />

                <Modal isOpen={isPaymentIntentModalOpen} onClose={handleClosePaymentIntentModal} size="lg">
                    <ModalOverlay/>
                    <ModalContent>
                        <ModalHeader pr={14}>
                            <Flex justify="space-between" align="center" gap={2} flexWrap="wrap">
                                <Text fontSize="lg" fontWeight="700">Stripe Payment Details</Text>
                                {selectedOrderForRefund && (
                                    <Badge colorScheme="purple">
                                        Card payment prints: {selectedOrderForRefund.cardPaymentDetailsPrintCount ?? 0}
                                    </Badge>
                                )}
                            </Flex>
                        </ModalHeader>
                        <ModalCloseButton/>
                        <ModalBody pb={6}>
                            {isPaymentIntentLoading && <Text>Loading payment details...</Text>}
                            {!isPaymentIntentLoading && selectedPaymentIntent && (
                                <VStack align="stretch" spacing={2}>
                                    <Flex justifyContent="space-between" alignItems="center">
                                        <Text fontWeight="600">Payment Intent</Text>
                                        <Badge colorScheme={getStripeStatusColorScheme(selectedPaymentIntent.status)}>
                                            {selectedPaymentIntent.status || "unknown"}
                                        </Badge>
                                    </Flex>
                                    <Box bg="gray.50" p={3} borderRadius="md">
                                        <Text><b>ID:</b> {selectedPaymentIntent.id}</Text>
                                        <Text><b>Amount:</b> {(selectedPaymentIntent.amount / 100).toFixed(2)} {selectedPaymentIntent.currency?.toUpperCase()}
                                        </Text>
                                        <Text><b>Created:</b> {new Date(selectedPaymentIntent.created * 1000).toLocaleString()}
                                        </Text>
                                        <Text>
                                            <b>Stripe customer ID:</b>{" "}
                                            {selectedPaymentIntent.customer || "—"}
                                        </Text>
                                        <Text>
                                            <b>Receipt email:</b>{" "}
                                            {selectedPaymentIntent.receipt_email
                                                || selectedPaymentIntent.metadata?.customer_email
                                                || "N/A"}
                                        </Text>
                                        <Text><b>Description:</b> {selectedPaymentIntent.description || "N/A"}</Text>
                                    </Box>
                                    <Divider/>
                                    <Text fontWeight="600">Refunds</Text>
                                    <Box bg="gray.50" p={3} borderRadius="md">
                                        {paymentRefunds.length === 0 ? (
                                            <Text color="gray.600">No refunds found.</Text>
                                        ) : (
                                            <VStack align="stretch" spacing={2}>
                                                {paymentRefunds.map((refund: any, idx: number) => (
                                                    <Box key={refund.refundId || idx} p={2} bg="white" borderRadius="md"
                                                         border="1px solid" borderColor="gray.200">
                                                        <Text><b>Refund ID:</b> {refund.refundId || "N/A"}</Text>
                                                        <Text><b>Date:</b> {formatRefundCreated(refund.created)}</Text>
                                                        <Text>
                                                            <b>Amount:</b> {refund.amount !== undefined
                                                            ? `${selectedPaymentIntent.currency?.toUpperCase() || ""} ${Number(refund.amount).toFixed(2)}`
                                                            : "N/A"}
                                                        </Text>
                                                        <Text><b>Comment:</b> {refund.note || "N/A"}</Text>
                                                        <Text><b>Status:</b> {refund.success ? "Success" : "Failed"}</Text>
                                                    </Box>
                                                ))}
                                            </VStack>
                                        )}
                                    </Box>
                                    {hasPermission(orderRefundPermission) &&
                                        selectedOrderForRefund?.stripeTransactionId &&
                                        canRefundByPaymentIntentStatus &&
                                        availableRefundAmount > 0 && (
                                        <>
                                            <Divider/>
                                            <Text fontWeight="600">Create refund</Text>
                                            <Box bg="gray.50" p={3} borderRadius="md">
                                                <Text><b>Total paid:</b> {`${selectedPaymentIntent.currency?.toUpperCase()} ${totalCapturedAmountInMajor.toFixed(2)}`}</Text>
                                                <Text><b>Already refunded:</b> {`${selectedPaymentIntent.currency?.toUpperCase()} ${Number(refundedAmount).toFixed(2)}`}</Text>
                                                <Text><b>Available to refund:</b> {`${selectedPaymentIntent.currency?.toUpperCase()} ${availableRefundAmount.toFixed(2)}`}</Text>
                                            </Box>
                                            <Box opacity={enablePartialRefundUi ? 1 : 0.5}>
                                                <Text mb={2} fontWeight="600">Refund type</Text>
                                                <RadioGroup value={refundMode}
                                                            onChange={(val) => setRefundMode(val as "full" | "partial")}
                                                            isDisabled={!enablePartialRefundUi}>
                                                    <Stack direction="row">
                                                        <Radio value="full">Full refund</Radio>
                                                        <Radio value="partial">Partial refund</Radio>
                                                    </Stack>
                                                </RadioGroup>
                                            </Box>
                                            {refundMode === "partial" && (
                                                <Box opacity={enablePartialRefundUi ? 1 : 0.5}>
                                                    <Text mb={2} fontWeight="600">Partial amount</Text>
                                                    <Input
                                                        value={partialRefundAmount}
                                                        onChange={(e) => setPartialRefundAmount(e.target.value)}
                                                        placeholder="Enter amount (e.g. 10.50)"
                                                        type="number"
                                                        step="0.01"
                                                        min="0"
                                                        isDisabled={!enablePartialRefundUi}
                                                    />
                                                </Box>
                                            )}
                                            <Box>
                                                <Text mb={2} fontWeight="600">Comment (optional)</Text>
                                                <Textarea
                                                    value={refundNoteMessage}
                                                    onChange={(e) => setRefundNoteMessage(e.target.value)}
                                                    placeholder="Refund comment (reason: requested_by_customer, text is saved to metadata)"
                                                    rows={3}
                                                    size="sm"
                                                />
                                            </Box>
                                        </>
                                    )}
                                    <Flex justifyContent="flex-end" gap={2} pt={2} flexWrap="wrap">
                                        {hasPermission(orderEditPermission) && selectedOrderForRefund && (
                                            <Button
                                                variant="outline"
                                                colorScheme="gray"
                                                size="sm"
                                                leftIcon={<Icon as={FiPrinter}/>}
                                                isLoading={isStripeDetailsPrinting}
                                                isDisabled={isPaymentIntentLoading || isRefundSubmitting}
                                                onClick={handleCardPaymentDetailsPrint}
                                            >
                                                Print summary
                                            </Button>
                                        )}
                                        {hasPermission(orderRefundPermission) &&
                                            selectedOrderForRefund?.stripeTransactionId &&
                                            canRefundByPaymentIntentStatus &&
                                            availableRefundAmount > 0 && (
                                            <Button
                                                colorScheme="blue"
                                                size="sm"
                                                onClick={handleSubmitRefund}
                                                isLoading={isRefundSubmitting}
                                                isDisabled={isPaymentIntentLoading || !selectedPaymentIntent || !canRefundByPaymentIntentStatus || availableRefundAmount <= 0}
                                            >
                                                Confirm Refund
                                            </Button>
                                        )}
                                    </Flex>
                                </VStack>
                            )}
                            {!isPaymentIntentLoading && !selectedPaymentIntent && (
                                <Text>No Stripe payment details found for {selectedPaymentIntentId || "this order"}.</Text>
                            )}
                        </ModalBody>
                    </ModalContent>
                </Modal>

                <Box display="flex" flexDir="column" height="100%">
                    <VStack align="stretch" spacing={4} w="100%" mb={3}>
                        <OrderHistoryFilters
                            isMobile={Boolean(isMobile)}
                            columnFilters={columnFilters}
                            setColumnFilters={setColumnFilters}
                            dealershipSuggestions={dealershipSuggestions}
                            showDealershipColumn={showDealershipColumn}
                            showAmountColumn={showAmountColumn}
                            showStatusColumn={showStatusColumn}
                            statusFilterOptions={statusFilterOptions}
                            currentSortLabel={currentSortLabel}
                            onResetSort={() => setSorting([])}
                            isExcluded={isExcluded}
                            onExcludedChange={setIsExcluded}
                            countSelected={countSelected}
                            onClearSelection={() => setSelectedItems([])}
                            selectedItems={selectedItems}
                            onRemoveSelectedOrder={(item) => handleOnclickNew(item, true)}
                            actionMenu={orderHistoryActionMenu}
                            showCardPaidStatusFilter={isRoleAdmin()}
                            cardPaidOrderCount={cardPaidOrderCount}
                            isCardPaidFilterActive={isCardPaidFilterActive}
                            onCardPaidFilterClick={handleCardPaidFilterClick}
                            onHelpersReady={({getFilterValue, getFilterIconColor, onHeaderFilterClick, showColumnHeaderFunnels: headerFunnels}) => {
                                getFilterValueRef.current = getFilterValue;
                                getFilterIconColorRef.current = getFilterIconColor;
                                onHeaderFilterClickRef.current = onHeaderFilterClick;
                                setShowColumnHeaderFunnels(headerFunnels);
                            }}
                        />
                    </VStack>
                    {isLoading ? <Loader/> :
                        (isPdf === 0 ?
                                <Box>
                                    {idState ?
                                        <Box>
                                            <CloseButton ml={"auto"} boxSize={"8"}
                                                         onClick={() => setIdState(null)}/>
                                            <ClientForm links={[URLPaths.HOME, URLPaths.COMPANIES]}
                                                        isEditing={false}
                                                        isParent={true} companyId={idState.companyId}
                                                        dealershipId={idState.dealershipId}></ClientForm>
                                        </Box> :
                                        <Box overflowX={isMobile ? "visible" : "hidden"} width="100%">
                                            <Box minW={isMobile ? "100%" : desktopTableMinWidth}>
                                                {isMobile && renderMobileHeader()}
                                                {!isMobile && renderDesktopHeader()}
                                                {ListAll}
                                            </Box>
                                        </Box>
                                    }
                                </Box> :
                                <Box>
                                    <CloseButton ml={"auto"} boxSize={"8"} onClick={() => {
                                        setPdf(0)
                                        setGroupOrder(null)
                                        setSelectedItems([])
                                    }}/>
                                    <PDFViewer reqFilter={buildFilters(groupOrder)} orderIds={selectedItems}
                                               isPrint={isPrint}
                                               isDocumentTypes={isDocumentType}/>
                                </Box>
                        )
                    }
                </Box>
                {orderClientList?.count > 20 &&
                    <Box display="flex" justifyContent={{base: "center", lg: "flex-start"}}>
                        <Paginator step={20}
                                   limit={typeof orderClientList?.count === 'number' ? orderClientList?.count : 0}
                                   current={currentPaginatorPosition}
                                   swapPageTrigger={handlePageChange}/>
                    </Box>
                }
            </>
        );
    }
;

export default OrderHistory;